// @flow

import React from 'react';

import { Tooltip, Fab, Hidden } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import * as segment from '../../utils/segment';
import { getSnack } from '../../utils/snackbar';
import { fetchWithToken, getAvaBackendEndpoint } from '../../utils/http';
import AddIcon from '../../../assets/icons/add.svg';

const useStyles = makeStyles({
  fab: theme => ({
    backgroundColor: theme.palette.ava.navy,
    borderRadius: 22,
    boxShadow: 'none',
    color: 'white',
    fontSize: 16,
    fontWeight: 600,
    height: 44,
    marginLeft: 4.5,
    marginRight: 5,
    marginTop: 0,
    padding: '8px 15px',
    textTransform: 'none',
    width: 'auto',
    '&:hover': {
      backgroundColor: theme.palette.ava.navy,
      opacity: 0.9,
    },
  }),
  icon: {
  },
  text: { marginLeft: 10 },
});

type Props = {
  status: Object,
  scribe: boolean,
  theme: Object,
  user: Object
};

function AddParticipant(props: Props) {
  const { scribe, theme, user } = props;
  const classes = useStyles(theme);
  const { t } = useTranslation();

  const dispatchSnack = getSnack(useSnackbar());

  const shareLink = () => {
    const { status } = props;
    const url = status.links.deep2 || status.links.rw;
    if (window.navigator.share) {
      window.navigator.share({ url });
    } else {
      navigator.clipboard.writeText(url);
      dispatchSnack(
        t('addParticipant.theConversationLinkHasBeenCopiedToYourClipboard')
      );
    }
    segment.track('Invites Sent', {
      'Invite Method': 'Share Link',
    });
    const metricsToUpdate = {
      'Total Share Link': 1
    };
    fetchWithToken(
      `${getAvaBackendEndpoint()}/api/v1.1/users/${
        user.avaId
      }?firebaseAuthUID=${user.firebaseAuthUID || user.id}`,
      {
        method: 'PATCH',
        body: JSON.stringify({
          inviteMetrics: metricsToUpdate,
        }),
      }
    );
  };

  return (
    <Tooltip
      title={t('addParticipant.invite')}
      aria-label="share-link"
      enterDelay={300}
      leaveDelay={200}
    >
      <Fab
        variant="extended"
        className={classes.fab}
        onClick={() => shareLink()}
        style={{
        }}
      >
        <img height="22" width="22" alt="add" className={classes.icon} src={AddIcon} />
        {!scribe && (
          <Hidden only={['xs', 'sm']}>
            <span className={classes.text}>{t('addParticipant.add')}</span>
          </Hidden>
        )}
      </Fab>
    </Tooltip>
  );
}

export default withTheme(AddParticipant);
